<template>
  <div :class="`relative ${textColor}`">
    <div class="relative w-full h-full">
      <div class="absolute w-full h-full star-shaped">
        <div
          class="h-full"
          :class="starColor"
          :style="`width: ${starWidth}%`" />
      </div>
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="absolute w-full h-full">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.2064 6.17467L2.07483 6.80601L5.06828 9.87398L4.37426 14.1285L7.99999 12.1243L11.6259 14.1286L10.9319 9.87398L13.9253 6.80603L9.7936 6.17467L8 2.35348L6.2064 6.17467ZM5.52788 5.26675L0 6.11145L4.00007 10.2111L3.05577 16L8 13.2669L12.9444 16L12.0001 10.2111L16 6.11163L10.4721 5.26675L8 0L5.52788 5.26675Z"
          fill="currentColor" />
      </svg>
    </div>

    <div
      class="absolute -bottom-6 whitespace-nowrap"
      :class="`${labelPositionClasses} ${displayLabel ? 'block' : 'hidden'}`">
      {{ label }}
    </div>
  </div>
</template>

<script>
export const MAX_VALUE = 1;
export const LABEL_POSITION = {
  left: "left-0",
  right: "right-0",
  center: "transform -translate-x-1/2 left-1/2"
};
export default {
  name: "StarRating",
  props: {
    positionLabel: {
      type: String,
      default: "center",
      validator: (value) => {
        return Object.keys(LABEL_POSITION).includes(value);
      }
    },
    label: { type: String, default: null },
    displayLabel: { type: Boolean, default: false },
    forceHoveredState: { type: Boolean, default: false },
    enableHoverEffects: { type: Boolean, default: false },
    value: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= MAX_VALUE
    }
  },
  computed: {
    labelPositionClasses() {
      return LABEL_POSITION[this.positionLabel];
    },
    textColor() {
      if (this.forceHoveredState) {
        return "text-blue-2 cursor-pointer";
      }

      return this.enableHoverEffects
        ? "text-blue hover:text-blue-2 cursor-pointer"
        : "text-blue";
    },
    starColor() {
      if (!this.value) {
        return "bg-transparent";
      }

      if (this.forceHoveredState) {
        return "bg-blue-2";
      }

      return this.enableHoverEffects ? "bg-blue hover:bg-blue-2" : "bg-blue";
    },
    starWidth() {
      return ((this.value / 1) * 100).toFixed(2) || 0;
    }
  }
};
</script>
<style scoped>
.star-shaped {
  clip-path: polygon(50% 0.5%,
  65.1% 33.3%,
  99.3% 38.5%,
  74.5% 63.7%,
  80.4% 99%,
  50% 82.5%,
  19.5% 99%,
  25.5% 63.7%,
  0.5% 38.5%,
  35% 33.3%);
}
</style>
